<template>
  <div class="d-flex flex-column align-items-start" :style="{ minHeight }">
    <h4>{{ title }}</h4>
    <slot name="description">
      <p v-if="description">
        {{ description }}
      </p>
    </slot>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  descriptionLink: {
    type: Object,
    default: () => ({}),
  },
  minHeight: {
    type: String,
    default: '0px',
  },
});
</script>

<style scoped lang="less">
div {
  h4 {
    font-size: 18px;
    font-weight: 600;
    line-height: 150%;
    color: @text-darkest;
  }

  p, :deep(p) {
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    color: @text-dark;
  }

  a, :deep(a) {
    color: @text-brand;
    cursor: pointer;
  }
}
</style>
